export default "__VITE_ASSET__B0l7a_8J__"